module.exports = __webpack_public_path__ + "img/phone.564b0e27.png";